/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { TextInput, Select, SelectItem } from 'carbon-components-react';
import isEqual from 'lodash/isEqual';

export class TestToolRedirectUri extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      redirectUri: ''
    };
  }

  componentDidMount() {
    this.configure(this.props);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props)) {
      this.configure(this.props);
    }
  }

  configure(props) {
    this.setState({ redirectUri: props.value.redirectUri });
  }

  handleChange(event) {
    this.setState({ redirectUri: event.target.value });

    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange({ redirectUri: event.target.value });
    }
  }

  render() {
    let { t, value } = this.props;

    let { redirectUri } = this.state;

    let redirectUris = value.redirectUris;
    let uriSelector;
    let uriInput;

    if (redirectUris.length > 0 && redirectUris[0] !== '') {
      // need a dropdown
      uriSelector = (
        <Select onChange={this.handleChange} id="redirectUri-select" defaultValue={redirectUris[0]} hideLabel>
          {redirectUris.map((param) => {
            return <SelectItem key={param} value={param} text={param} />;
          })}
          <SelectItem key={''} value={''} text={t('other')} />
        </Select>
      );
    }
    if (redirectUris[0] === '' || redirectUris.indexOf(redirectUri) === -1) {
      uriInput = (
        <TextInput
          className="redirectUriField"
          type="input"
          hideLabel={true}
          labelText={t('explorer_redirect_uri')}
          id="redirectUriField"
          value={redirectUri}
          onChange={this.handleChange}
        />
      );
    }

    return (
      <div className="redirectUri">
        <div className="labelText">{t('explorer_redirect_uri')}</div>
        {uriSelector}
        {uriInput}
      </div>
    );
  }
}

export default withTranslation()(TestToolRedirectUri);
